var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunningRoute(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.0449,
    transform: "rotate(-167.356 12 12)",
    fill: "#299900",
    fillOpacity: 0.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0006,
    cy: 12.0001,
    r: 6.15654,
    transform: "rotate(-167.356 12.0006 12.0001)",
    fill: "#299900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7819 12.1661C15.815 12.1519 15.8432 12.1283 15.863 12.0983C15.8828 12.0682 15.8934 12.033 15.8934 11.997C15.8934 11.961 15.8828 11.9258 15.863 11.8958C15.8432 11.8657 15.815 11.8422 15.7819 11.828L10.4858 9.55829L10.4855 9.55803L10.3211 9.4873C10.29 9.47392 10.2558 9.4694 10.2222 9.47426C10.1887 9.47911 10.1571 9.49314 10.131 9.5148C10.105 9.53646 10.0854 9.56491 10.0745 9.597C10.0635 9.62909 10.0617 9.66357 10.0692 9.69664L10.1082 9.87087L10.1079 9.87165L10.5804 11.997L10.1079 14.1224L10.1079 14.1234L10.0689 14.2977C10.0616 14.3307 10.0635 14.3651 10.0745 14.3971C10.0854 14.4291 10.105 14.4575 10.1311 14.4791C10.1571 14.5007 10.1886 14.5147 10.2221 14.5195C10.2556 14.5243 10.2898 14.5198 10.3209 14.5065L15.7819 12.1661ZM14.8137 12.1809L10.9161 12.1809L10.9481 12.0371C10.954 12.0107 10.954 11.9834 10.9481 11.957L10.9161 11.8132L14.8137 11.8132L15.2426 11.997L14.814 12.1811L14.8137 12.1809Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunningRoute);
export default __webpack_public_path__ + "static/media/runningRoute.45d85a408b7aff5aadf9192aa9f38fb4.svg";
export { ForwardRef as ReactComponent };